import { useIntl, useSetPageTopBarHeaderLeft, useSettings } from '@capsicum/common';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';

export const useExportAndCloseAccountCompletion = () => {
	// Remove back button from the top bar
	useSetPageTopBarHeaderLeft(null);

	const { $t } = useIntl();
	const { settings } = useSettings();

	const resolver = zodResolver(
		z.object({
			checkbox: z.literal<boolean>(true)
		})
	);

	return {
		intlTexts: {
			closeApp: $t('settings.accountManagement.closeApp'),
			confirmHavingSavedPrivateKey: $t('settings.accountManagement.confirmHavingSavedPrivateKey'),
			copiedToClipboard: $t('settings.accountManagement.copiedPrivateKeyToClipboard'),
			copyPrivateKeyButton: $t('settings.accountManagement.copyPrivateKeyButton'),
			logOut: $t('global.button.logout'),
			yourPrivateKey: $t('settings.accountManagement.yourPrivateKey')
		},
		resolver,
		supportLink: settings.contactUsHereLink
	};
};
